export default __webpack_public_path__ + "static/media/vitals.d726e764.svg";